$(document).ready(function () {
    $(document).on("click", ".HeaderAreaMenu_parent.accordion", function () {
        $(this).find("svg").toggleClass("open");
        $(this).find("ul").slideToggle();
    });

    $(document).ready(function () {
        $(".HeaderArea .mouseOver")
            .mouseover(function (e) {
                $(this).find(".HeaderAreaMenu_pcChild").show();
                $(".HeaderAreaMenu_pcChild").attr("left", e.clientX);
                $(".HeaderAreaMenu_pcChild").attr("bottom", e.clientY);
            })
            .mouseout(function () {
                $(this).find(".HeaderAreaMenu_pcChild").hide();
            });
    });
});
